import api from 'Services/api';

export default async function fetchData(countryId) {
  const datafetched = await api.get(`/country/${countryId}/schools`).then((res) => res.data).catch((err) => err);
  return datafetched;
}
